<!-- Table tile: a 40px square that reads as video at a glance, previews muted
     on hover, and opens the full player on click. -->
<div class="video-tile" *ngIf="size === 'tile'"
     cdkOverlayOrigin #origin="cdkOverlayOrigin"
     [class.video-tile-unplayable]="!playable"
     (mouseenter)="onEnter()" (mouseleave)="onLeave()" (click)="open($event)"
     [title]="statusLabel + (duration ? ' · ' + duration : '')">
  <div class="tile-frame">
    <img class="tile-poster" *ngIf="poster" [src]="poster" alt="">
    <div class="tile-poster tile-poster-blank" *ngIf="!poster">
      <mat-icon>movie</mat-icon>
    </div>
    <span class="tile-play" *ngIf="playable">
      <mat-icon>play_arrow</mat-icon>
    </span>
    <span class="tile-duration" *ngIf="duration">{{ duration }}</span>
    <span class="tile-status" *ngIf="!playable" [ngClass]="'status-' + video.status">
      {{ statusLabel }}
    </span>
  </div>

  <!-- Render outside the scrolling table so the complete preview stays visible. -->
  <ng-template cdkConnectedOverlay [cdkConnectedOverlayOrigin]="origin"
               [cdkConnectedOverlayOpen]="hovering" [cdkConnectedOverlayPush]="true"
               [cdkConnectedOverlayViewportMargin]="8"
               [cdkConnectedOverlayPositions]="[
                 {originX: 'end', originY: 'top', overlayX: 'start', overlayY: 'top', offsetX: 8},
                 {originX: 'start', originY: 'top', overlayX: 'end', overlayY: 'top', offsetX: -8}
               ]">
    <div class="tile-expanded">
      <video #preview *ngIf="playable" class="expanded-player" [muted]="true" autoplay loop playsinline preload="auto"
             (canplay)="playPreview()" [poster]="video.poster_url || poster" [src]="source"></video>
      <img class="expanded-player" *ngIf="!playable && poster" [src]="poster" alt="">
      <div class="expanded-label">
        <span class="expanded-kind">Video</span>
        <span *ngIf="duration">{{ duration }}</span>
        <span *ngIf="!playable">{{ statusLabel }}</span>
      </div>
    </div>
  </ng-template>
</div>

<!-- Detail card: a real player with controls, sized to match the photo strip. -->
<div class="video-card" *ngIf="size === 'card'" [class.video-card-unplayable]="!playable">
  <div class="card-frame">
    <video *ngIf="playable" class="card-player" controls playsinline preload="metadata"
           [poster]="poster" [src]="source"></video>

    <div class="card-empty" *ngIf="!playable">
      <mat-icon class="empty-icon">movie_filter</mat-icon>
      <div class="empty-status" [ngClass]="'status-' + video.status">{{ statusLabel }}</div>
      <div class="empty-reason" *ngIf="video.status_reason">{{ video.status_reason }}</div>
    </div>

    <button type="button" class="card-expand" *ngIf="playable" (click)="open($event)"
            aria-label="Open full player">
      <mat-icon>open_in_full</mat-icon>
    </button>
  </div>

  <div class="card-meta">
    <span class="meta-kind">Video</span>
    <span class="meta-slot">Slot {{ video.place }}</span>
    <span *ngIf="duration">{{ duration }}</span>
    <span [class.meta-off]="!video.has_audio" [title]="dimensions">{{ video.has_audio ? 'audio' : 'silent' }}</span>
    <span class="meta-deleted" *ngIf="video.deletedAt">deleted</span>
  </div>
  <div class="card-caption" *ngIf="video.caption">“{{ video.caption }}”</div>
</div>
